import api from "../../../api/axios";

export const fetchMyCompany = () =>
  api.get("/companies/mine/").then((res) => res.data);

export const createCompany = (body) =>
  api.post("/companies/", body).then((res) => res.data);

export const fetchCompany = (companyId) =>
  api.get(`/companies/${companyId}/`).then((res) => res.data);

export const patchCompany = (companyId, body, config) =>
  api.patch(`/companies/${companyId}/`, body, config).then((res) => res.data);

/** Multipart profile branding (logo/banner) via existing CompanyWriteSerializer fields. */
export const patchCompanyMultipart = (companyId, formData) =>
  api
    .patch(`/companies/${companyId}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((res) => res.data);

export const archiveCompany = (companyId) =>
  api.post(`/companies/${companyId}/archive/`).then((res) => res.data);

export const leaveCompany = (companyId) =>
  api.post(`/companies/${companyId}/leave/`);

export const transferOwnership = (companyId, newOwnerId) =>
  api.post(`/companies/${companyId}/transfer-ownership/`, {
    new_owner_id: newOwnerId,
  });

export const fetchMembers = (companyId, status = "active") =>
  api
    .get(`/companies/${companyId}/members/`, {
      params: status ? { status } : undefined,
    })
    .then((res) => res.data);

export const patchMember = (companyId, memberId, body) =>
  api
    .patch(`/companies/${companyId}/members/${memberId}/`, body)
    .then((res) => res.data);

export const removeMember = (companyId, memberId) =>
  api.delete(`/companies/${companyId}/members/${memberId}/`);

export const suspendMember = (companyId, memberId) =>
  api.post(`/companies/${companyId}/members/${memberId}/suspend/`);

export const resumeMember = (companyId, memberId) =>
  api.post(`/companies/${companyId}/members/${memberId}/resume/`);

export const setFinancePermission = (companyId, memberId, enabled) =>
  api
    .patch(`/companies/${companyId}/members/${memberId}/finance-permission/`, {
      can_access_company_finance: enabled,
    })
    .then((res) => res.data);

export const fetchInvitations = (companyId, status) =>
  api
    .get(`/companies/${companyId}/invitations/`, {
      params: status ? { status } : undefined,
    })
    .then((res) => res.data);

export const revokeInvitation = (companyId, invitationId) =>
  api.delete(`/companies/${companyId}/invitations/${invitationId}/`);

export const resendInvitation = (companyId, invitationId) =>
  api
    .post(`/companies/${companyId}/invitations/${invitationId}/resend/`)
    .then((res) => res.data);

export const revealInvitationToken = (companyId, invitationId) =>
  api
    .post(`/companies/${companyId}/invitations/${invitationId}/reveal-token/`)
    .then((res) => res.data);

export const fetchJoinRequests = (companyId, status) =>
  api
    .get(`/companies/${companyId}/join-requests/`, {
      params: status ? { status } : undefined,
    })
    .then((res) => res.data);

export const approveJoinRequest = (companyId, requestId) =>
  api
    .post(`/companies/${companyId}/join-requests/${requestId}/approve/`)
    .then((res) => res.data);

export const rejectJoinRequest = (companyId, requestId) =>
  api
    .post(`/companies/${companyId}/join-requests/${requestId}/reject/`)
    .then((res) => res.data);

export const cancelJoinRequest = (companyId, requestId) =>
  api
    .post(`/companies/${companyId}/join-requests/${requestId}/cancel/`)
    .then((res) => res.data);

export const fetchMyInvitations = () =>
  api.get("/companies/my-invitations/").then((res) => res.data);

export const fetchMyJoinRequests = (status) =>
  api
    .get("/companies/my-join-requests/", {
      params: status ? { status } : undefined,
    })
    .then((res) => res.data);

export const fetchInvitationByToken = (token) =>
  api.get(`/companies/invitations/by-token/${token}/`).then((res) => res.data);

export const acceptInvitationByToken = (token) =>
  api
    .post(`/companies/invitations/by-token/${token}/accept/`)
    .then((res) => res.data);

export const declineInvitationByToken = (token) =>
  api
    .post(`/companies/invitations/by-token/${token}/decline/`)
    .then((res) => res.data);
